import { pricing, maxProfilesWord } from '../lib/pricing'

export interface FaqItem {
  question: string
  answer: string
  /** Shown in the compact homepage FAQ. */
  home?: boolean
  /** Shown on the pricing page. */
  billing?: boolean
}

export const faqs: FaqItem[] = [
  {
    question: 'What ages is it for?',
    answer:
      'Ages 7 and up. The reading level is aimed at a confident seven-year-old, and the ideas are chosen so older kids still learn something new.',
    home: true,
  },
  {
    question: 'How long is an adventure?',
    answer:
      'Roughly five to eight minutes. An adventure is a short run of illustrated cards, followed by one question and a badge to keep. It is designed to finish, not to keep going.',
    home: true,
  },
  {
    question: 'Is there a free trial?',
    answer: `No. ${pricing.billingTerms} You can try a free sample adventure on this website without an account, payment or email.`,
    home: true,
    billing: true,
  },
  {
    question: 'How does the yearly plan work?',
    answer: `${pricing.annualPrice} ${pricing.annualPeriod}, charged in full upfront when you subscribe, then once a year when it renews. The monthly plan is ${pricing.monthlyPrice} ${pricing.monthlyPeriod}, billed monthly.`,
    billing: true,
  },
  {
    question: 'Can I use one subscription for more than one child?',
    answer: `Yes. One subscription covers up to ${maxProfilesWord} child profiles, each with its own progress and badges.`,
    home: true,
    billing: true,
  },
  {
    question: 'Can I buy it on this website?',
    answer: `No. ${pricing.checkoutNote} Lightning Learn is coming to iPhone and is not on the App Store yet.`,
    billing: true,
  },
  {
    question: 'Does it work offline?',
    answer:
      'Adventures your child has already opened are stored on the device, so a car ride or a patchy connection is usually fine.',
  },
  {
    question: 'What can my child reach inside the app?',
    answer:
      'The child experience has no ads, no chat and no content from other users. Subscription options and settings sit behind a parent check.',
    home: true,
  },
  {
    question: 'What do you collect about my child?',
    answer:
      'Profiles can include a nickname, buddy and interests, plus lesson progress, answers or quiz results, measured lesson time, earned badges and activity records. Saved profiles can also contain a legacy daily learning-goal value, although current child setup does not ask for it. We do not ask for a child’s email address, age range or reading comfort in child setup. Our privacy policy sets out the full detail.',
  },
]
